import type { Camera } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { HALF_PI } from '../../core/util/math/Math'
import { VERTICES_PER_TILE } from '../consts'

export default function createThreeOrbitControls(
  elem: HTMLElement,
  camera: Camera
): OrbitControls {
  const controls = new OrbitControls(camera, elem)

  controls.enablePan = false

  // call this only in static scenes (i.e., if there is no animation loop)
  //controls.addEventListener( 'change', render )

  // an animation loop is required when either damping or auto-rotation are enabled
  // controls.enableDamping = true
  // controls.dampingFactor = 0.01

  // controls.mouseButtons = {
  //   LEFT: THREE.MOUSE.PAN,
  //   MIDDLE: THREE.MOUSE.DOLLY,
  //   RIGHT: THREE.MOUSE.ROTATE
  // }

  // controls.screenSpacePanning = false

  // controls.minDistance = 10
  // controls.maxDistance = 800
  controls.minDistance = 25 * (VERTICES_PER_TILE / 32)
  controls.maxDistance = 35 * (VERTICES_PER_TILE / 32)

  // allow top-down viewing angle
  controls.minPolarAngle = (0.6) * (HALF_PI)

  // prevent moving camera below floor
  controls.maxPolarAngle = (0.9) * (HALF_PI)

  // const defaultPolarAngle = (minPolarAngle + maxPolarAngle) / 2.4

  // setMapControlsPolarAngle(controls, minPolarAngle)

  // controls.zoomToCursor = true
  // controls.screenSpacePanning = true
  // controls.update()

  // controls.listenToKeyEvents(window)

  // controls.autoRotate = false

  // controls.keyPanSpeed = 50
  // controls.panSpeed = 50

  // controls.addEventListener('change', () => {
  //   // console.log('camera rotation', toFixed1(camera.rotation.x), toFixed1(camera.rotation.y), toFixed1(camera.rotation.z))
  //   console.log('camera position', toFixed1(camera.position.x), toFixed1(camera.position.y), toFixed1(camera.position.z))
  //   console.log('controls.getPolarAngle()', toFixed1(controls.getPolarAngle()))
  // })

  // setMapControlsPolarAngle(controls, 8)
  // setMapControlsPolarAngle(controls, PI * (1/4))

  return controls
}


